<div *ngIf="showSpinner" class="spinner d-flex" >
    <div class="m-auto">
        <div class="spinner-border text-primary spinner-size" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="spinner-text mt-4">
            Esperando información...
        </div>

    </div>
</div>